module.exports = __webpack_public_path__ + "static/img/son8_active.8b1af0e0.png";